app.service('slider360',function() {
	var $self;
	function setElements(){
		$self=$("#multimedia-presentation");
	}
	function setEvents(){
		$self.slider();
	}
	function init(url){
		if(!$self){
			setElements();
			setEvents();
		}
	}

	return {
		init
	};
});



const defaultOptions = {
	threshold: 20,
};

class Slider {
	/**
	 *
	 * @param {jQuery} container
	 * @param {object} options
	 */
	constructor (container, options) {
		this.container = container;
		this.options = jQuery.extend(defaultOptions, options);

		this.init();
	}

	/**
	 * Initialize the slider
	 */
	init () {
		this.images = this.container.find('img');
		this.images.first().addClass('active');
		this.currentImage = 0;
		this.loadedImages = 0;
		this.maxWidth = 800;
		this.maxHeight = 590;
		this.loaded = false;
		this.dragging = false;
		this.progress=this.container.find('.progress');
		this.status=this.container.find('.status span');

		this.container.on('mousedown touchstart', jQuery.proxy(this.dragStartEventHandler, this));
		jQuery(window).on('mouseup touchend', jQuery.proxy(this.dragEndEventHandler, this));
		jQuery(window).on('mousemove touchmove', jQuery.proxy(this.dragMoveEventHandler, this))
		jQuery(window).on('resize', jQuery.proxy(this.windowResizeEventHandler, this))

		this.images.one('load', (event) => {
			let image = jQuery(event.target);

			this.imageResize(image);

			this.loaded = (++this.loadedImages === this.images.length);

			this.progress.text(parseInt(100*this.loadedImages/this.images.length)+"%");
			if(this.loadedImages==this.images.length){
				this.container.removeClass('loading');
			}
		}).each((index, element) => {
			if (element.complete) {

				let image = jQuery(element);
				this.imageResize(image);

				this.loaded = (++this.loadedImages === this.images.length);
				this.progress.text(parseInt(100*this.loadedImages/this.images.length)+"%");
				if(this.loadedImages==this.images.length){
					this.container.removeClass('loading');
				}
			}
		});
	}

	imageResize (image) {
		var height = image.height();
		var width = image.width();
		var ratio = width/height;
		if(width>this.maxWidth){
			width=this.maxWidth;
			height=parseInt(this.maxWidth/ratio);
		}
		if(height>this.maxHeight){
			height=this.maxHeight;
			width=parseInt(this.maxHeight*ratio);
		}
		image.css({
			'height': height,
			'width': width,
		});
		this.container.css({
			'height': height,
			'width': width,
			'margin-top': parseInt((this.maxHeight-height)/2)
		});
	}
	/**
	 * Handle window resize event
	 * @param {Event} event
	 */
	windowResizeEventHandler (event) {
		if (this.loaded) {
			this.container.css({
				'height': '',
				'width': ''
			});
			let image = this.images.first();

			this.container.css({
				'height': image.height(),
				'width': image.width(),
			});
		}
	}

	/**
	 * Handle drag start event (mousedown, touchdown)
	 * @param {Event} event
	 */
	dragStartEventHandler (event) {
		let X = event.pageX;
		// Normalize touch X position
		if (event.type === 'touchstart') {

			if (event.touches.length === 1) {
				X = event.touches[0].pageX;
			} else {
				return;
			}
		} else {
			event.preventDefault();
		}

		this.dragging = true;
		this.dragStartPosition = {
			currentImage: this.currentImage,
			X,
		};


	}

	/**
	 * Handle drag end event (mouseup, touchup)
	 * @param {Event} event
	 */
	dragEndEventHandler (event) {
		this.dragging = false;
	}

	/**
	 * Handle drag move
	 * @param {Event} event
	 */
	dragMoveEventHandler (event) {
		if (this.dragging) {
			let X = event.pageX;

			// Normalize touch X position
			if (event.type === 'touchmove') {
				if (event.touches.length === 1) {
					X = event.touches[0].pageX;
				} else {
					return;
				}
			}

			let distanceFromStart = this.dragStartPosition.X - X;
			let slidesToMove = Math.floor(distanceFromStart / this.options.threshold);
			let nextImage = (this.dragStartPosition.currentImage + slidesToMove) % this.images.length;

			this.images.eq(this.currentImage).removeClass('active');
			this.images.eq(nextImage).addClass('active');
			this.currentImage = nextImage;

			var left=parseInt((100-(100*nextImage/this.images.length)%100)%100);
			this.status.css('left',left+'%')
		}
	}
}


/**
 * Declare jQuery plugin for slider-360
 * @param options
 * @returns {jQuery}
 */
jQuery.fn.slider = function(options) {
	this.data('slider', new Slider(this, options));

	return this;
};
